import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as R from 'ramda';
import * as _ from 'lodash';
import moment from 'moment';
import Select from 'react-select-nested-group';
import { subDays } from 'date-fns';
import DateTime from 'react-datetime';
import { DateRangePicker } from 'react-date-range';
import { Popover, PopoverBody } from 'reactstrap';

import Users from '../../ducks/Users';
import Things from '../../ducks/Things';

import { Spinner } from '../common/Spinner/index';


import './index.css';
import Modal from 'react-bootstrap4-modal';

const hoursArray = R.unfold(h => h <= 24 ? [h, h + 1] : false, 1);

class DeviceDetailReport extends Component {

  constructor() {
    super();
    this.state = {
      user: {},
      popoverOpen: false,
      report:false,
      loading: true,
      selectedDate : moment(),
      selectedGroups:[],
      userGroups:[],
      vehicleNumberPlate: [],
      things: [],
      notificationSelected: [],
      notifications: [],
      maxDateRange : new Date(),
      selectedHours : { value: 12, label: 12 },
      dateRangePicker: {
        selection: {
          startDate: subDays(new Date(), 2),
          endDate: new Date(),
          key: 'selection',
        },
      },
      collapse: [],
      showModal: false,
      lat: 0,
      lng: 0,
      skip:0
    }

  }

  async componentDidMount() {

    let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    let userData = JSON.parse(localStorage.getItem("user"));
    let userGroups = userData['user']['group'];
    if (userGroups['child']){
      let groups = userGroups['child'];
      const mappedGroups = R.map(group => ({ value: group._id, label: `${group.name || 'N/A'}` }))(groups);
      await this.setState({ ...this.state, userGroups: mappedGroups });
    }
    await this.props.thingsActions.getGroupVehicles({ groupId:  companyInfo.groupId });
  }

  setSelectedDate  = async (selectedDate) => {
    await this.setState({ ...this.state, selectedDate });
  };


  setSelectedHours = async (selectedHours) => {
    await this.setState({ ...this.state, selectedHours });
  };

  searchVehicle = async (selectedOption) => {
    await this.setState({ ...this.state, things: selectedOption,skip:0 });
  };

  selectNotification = async (selectedOption) => {
    await this.setState({ ...this.state, notificationSelected: selectedOption || [] ,skip:0});
  };

  toggle = () => {
    this.setState({ ...this.state, popoverOpen: !this.state.popoverOpen });
  };

  async generateExcell(){
    let obj ={};
      let vehicels = [];

      if (this.state.things) {
        vehicels = _.map(this.state.things, (item) => item.value);
        if (vehicels.indexOf("All") != -1 ){
          vehicels = _.map(this.props.things, (item) => item.imei);
        }
      };
      const endDate = moment(this.state.selectedDate).add(this.state.selectedHours.value, 'hours');
   
      const interval = {
        startDate: moment(this.state.selectedDate),
        endDate: moment(endDate),
      };

      obj['vehicels'] = vehicels;
      obj['interval'] = interval;

      await this.props.actions.generateDeviceDetailReport(obj);
      this.setState({ ...this.state, 'report':true });
  }

  navigateToLogs = () => {
    this.props.history.push("/download/reports");
  };

  toggleModel = () => {
          this.setState({ ...this.state, 'report':false });
  };
  

  render() {

    const loader = <Spinner key='1' />;

    let options= [{value : 'All', label : 'ALL'}]
    
    this.props.things && this.props.things.map(thing => (
      options.push({ value: thing.imei, label: `${thing.name || 'N/A'}`})
    ));

    return(

        <>
              <Modal
          visible={this.state.report}
          dialogClassName="delete-modal-dialog"
        >
          <div>
            <button
              type="button"
              className="close close-x"
              aria-label="Close"
              onClick={() => this.toggleModel()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-heading">
            <h5 className="car-and-device-assig">Report Request</h5>
          </div>
          <div className="modal-body">
            <h6>Your report is being generated. Please check log section.</h6>
          </div>
          <div className="modal-footer model-btn">
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.navigateToLogs()}
            >
              View Reports
            </button>{" "}
            <button
              className="btn auxo-primary-btn"
              onClick={() => this.toggleModel()}
            >
              Cancel
            </button>
          </div>
        </Modal>
        <div className='row'>

       

        {/* <div className='col-lg-2 col-md-2 col-sm-2'>
          <div className='form-group'>
          <label>Date</label>
          <DateTime value={this.state.selectedDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={this.setSelectedDate} />
          </div>
        </div> */}
        {/* <div className='col-lg-2 col-md-2 col-sm-2'>
            <label >Duration (Hours)</label>
            <Select
                name="form-field-name"
                isClearable={false}
                isSearchable={true}
                placeholder="Select"
                defaultValue={this.state.selectedHours}
                onChange={this.setSelectedHours}
                options={hoursArray.map(h => {
                    return { value: h, label: h }
                })} />
        </div> */}
        <div className='col-lg-1 col-md-1 col-sm-1'>

        </div>
        <div className="col-lg-1" style={{marginTop: "25px"}}>
            <button className={`btn btn-primary search-btn  search-button`} style={{ padding: '7px 20px 7px 20px' }}  onClick={this.generateExcell.bind(this)}>Export</button>
        </div>
</div>
        </>
    );
  }
}

DeviceDetailReport.propTypes = {};
DeviceDetailReport.defaultProps = {};
const mapStateToProps = state => ({
  vehiclesPlateNumber: state.things.vehiclesPlateNumber,
  notifications: state.users.notifications.notifications,
  notificationsCount: state.users.notifications.notificationsCount,
  things: state.things.groupVehicles,
  hasMoreNotifications: state.users.hasMoreNotifications
});

const mapDispatchToProps = dispatch => ({

  actions: bindActionCreators(Users.creators, dispatch),
  thingsActions: bindActionCreators(Things.creators, dispatch)
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeviceDetailReport));
